// extracted by mini-css-extract-plugin
export default {"menuJoin":"c-a_eU","menuJoin_show":"c-a_eV"};